export default __webpack_public_path__ + "static/media/mypage_banner.ba523d0a.png";